export default __webpack_public_path__ + "static/media/D3847C65-D2A9-4830-BBF6-DAD028A3EFEA.a3e9346e.jpg";